import { makeStyles } from "@material-ui/core";
import tokens from "./designTokens";

// Dense analytics-table styling shared by the fleet table and the card shell.
export const MONO = "ui-monospace, SFMono-Regular, Menlo, monospace";

export const useTableStyles = makeStyles({
  card: {
    background: tokens.surface,
    border: `1px solid ${tokens.border}`,
    borderRadius: 12,
    boxShadow: "0 1px 2px rgba(16,24,40,.04)",
  },
  cardHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 14,
    flexWrap: "wrap",
    padding: "14px 20px",
    borderBottom: `1px solid ${tokens.border}`,
  },
  cardTitle: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    fontFamily: tokens.fontHeading,
    fontWeight: 600,
    fontSize: 15,
    color: "#232D2F",
  },
  countBadge: {
    background: tokens.primaryLight,
    color: tokens.primary,
    borderRadius: 20,
    padding: "1px 11px",
    fontFamily: tokens.fontBody,
    fontWeight: 700,
    fontSize: 13,
    marginLeft: 2,
  },
  tableWrap: { overflowX: "auto" },
  headCell: {
    padding: "9px 14px",
    borderBottom: `1px solid ${tokens.border}`,
    background: "#FAFBFC",
    fontFamily: tokens.fontBody,
    fontWeight: 600,
    fontSize: 11,
    lineHeight: 1.4,
    letterSpacing: ".04em",
    textTransform: "uppercase",
    color: tokens.textSecondary,
    whiteSpace: "nowrap",
  },
  sortLabel: {
    "&:hover, &:focus": { color: tokens.primary },
    "&.MuiTableSortLabel-active": { color: tokens.primary },
    "&.MuiTableSortLabel-active .MuiTableSortLabel-icon": { color: tokens.primary },
  },
  cell: {
    padding: "11px 14px",
    borderBottom: `1px solid ${tokens.divider}`,
    fontFamily: tokens.fontBody,
    fontSize: 13,
    color: tokens.textPrimary,
    verticalAlign: "top",
  },
  num: {
    textAlign: "right",
    whiteSpace: "nowrap",
    fontVariantNumeric: "tabular-nums",
  },
  clickRow: {
    cursor: "pointer",
    "&:hover": { backgroundColor: "#F6F8FA" },
  },
  motionChip: {
    height: 18,
    borderRadius: 5,
    fontFamily: tokens.fontBody,
    fontWeight: 700,
    fontSize: 10,
    letterSpacing: ".05em",
    textTransform: "uppercase",
    color: tokens.primary,
    background: tokens.primaryLight,
    border: "1px solid #D3E5E1",
    marginBottom: 5,
    "& .MuiChip-label": { padding: "0 7px" },
  },
  nameText: {
    fontFamily: tokens.fontBody,
    fontWeight: 600,
    fontSize: 13.5,
    color: "#232D2F",
  },
  monoSub: {
    fontSize: 11.5,
    color: tokens.textHint,
    marginTop: 3,
  },
  miniTrack: {
    display: "inline-block",
    width: 54,
    height: 6,
    borderRadius: 3,
    background: tokens.track,
    overflow: "hidden",
    flexShrink: 0,
  },
  modeBtn: {
    borderRadius: 999,
    padding: "8px 18px",
    fontFamily: tokens.fontBody,
    fontSize: 13,
    fontWeight: 700,
    textTransform: "none",
    color: "#fff",
    background: tokens.green,
    boxShadow: "0 6px 18px rgba(0,193,110,.25)",
    "&:hover": { background: tokens.green, boxShadow: "0 8px 22px rgba(0,193,110,.32)" },
  },
  modeBtnBack: {
    borderRadius: 999,
    padding: "8px 18px",
    fontFamily: tokens.fontBody,
    fontSize: 13,
    fontWeight: 700,
    textTransform: "none",
    color: tokens.primary,
    background: tokens.surface,
    border: `1px solid ${tokens.borderStrong}`,
    boxShadow: "0 2px 8px rgba(16,24,40,.06)",
    "&:hover": { background: tokens.surface },
  },
});
